import { Admin } from '@apis/index'
import { Actions, store } from '@store/index'
import { Helper } from '@utils/index'
import React, { ReactNode, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'

interface ProtectedRouteProps {
  allowedRoles?: string[]
  Component?: any
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowedRoles = ['admin'],
  Component,
}) => {
  const { data: user } = useSelector((state: any) => state.user)
  const [loading, setLoading] = useState<boolean>(true)

  const navigate = useNavigate()
  const fetchUser = async () => {
    const localStorageUser = await Helper.getUser()
    store.dispatch(Actions.set('user', localStorageUser))
    if (!!localStorageUser?.id && !!localStorageUser?.role) {
      if (localStorageUser?.role === 'admin') {
        await Admin.find({
          id: localStorageUser?.id,
        }).catch(() => {})
      }
    }
    setLoading(false)
  }
  useEffect(() => {
    if (!user?.id) {
      fetchUser()
    }
  }, [])
  if (loading) return null
  if (!user || !allowedRoles.includes(user?.role)) {
    return <Navigate to="/" replace />
  }
  return (
    <Component>
      <Outlet />
    </Component>
  )
}

export default ProtectedRoute
